import {eposAxios, epos2Axios} from "@/interceptors/axios";

class AssembleDataService {
    async getCustomer(customer_id) {
        return eposAxios.get('/index.php?page=ajax&function=getCustomer&customer_id='+customer_id);
    }

    async getCustomerLabelSettings(customer_id) {
        return epos2Axios.get('/api/assembly/getCustomerColour/'+customer_id);
    }

    async getCustomerHolderType(customer_id) {
        return epos2Axios.get('/api/customers/'+customer_id+'/towelholdertype');
    }

    async getOrderTowelHolderVolume(order_id) {
        return epos2Axios.get('/api/orders/'+order_id+'/towelholders/estimate');
    }

    async getOrderAssembledTowelHolderVolume(order_id, itemIDsToAssemble) {
        return epos2Axios.post('/api/orders/'+order_id+'/towelholders/estimate',{
            order_id: order_id,
            assembled_ids: JSON.stringify(itemIDsToAssemble)
        });
    }

    async getOrderByServiceTicket(barcode) {
        return eposAxios.get('/index.php?page=ajax&function=getOrderByServiceTicket&barcode='+barcode);
    }

    async getOrder(barcode) {
        return eposAxios.get('/index.php?page=ajax&function=getOrder&order_id='+barcode);
    }


    async getOrderNotes(order,type) {
        return eposAxios.get('/index.php?page=ajax&function=getOrderNotes&order='+order+'&type='+type);
    }

    async recordBarcodeScan(qrcode, type, action, workstation) {
        return eposAxios.get('/index.php?page=ajax&function=recordBarcodeScan&barcode='+qrcode+'&type='+type+'&action='+action+'&workstation='+workstation);
    }

    async getProductionStatusData() {
        return eposAxios.get('/index.php?page=ajax&function=getProductionStatusData');
    }

    printCustomerTag(cid) {
        return eposAxios.get(`/index.php?page=ajax&function=printCustomerTag&cid=${cid}`);
    }

    reprintOrderReceipt(order_id,parts) {
        return eposAxios.get(`/index.php?page=ajax&function=reprintOrderReceipt&order_id=${order_id}&part=${parts}`);
    }

    async setItemStatusAssembledAndPrintTag(items,tag,receipt,parts) {
        //return eposAxios.get(`/index.php?page=ajax&function=setItemStatusAssembledAndPrintTag&items=${items}&tag=${tag}&receipt=${receipt}&parts=${parts}`);

        const params = new URLSearchParams();
        params.append('items', items);
        params.append('tag', tag);
        params.append('receipt', receipt);
        params.append('parts', parts);

        return eposAxios.post(
            '/index.php?page=ajax&function=setItemStatusAssembledAndPrintTag',
            params,
            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );
    }

    reprintLastOrderReceipt(last_order_id, parts) {
        return eposAxios.get(`/index.php?page=ajax&function=reprintOrderReceipt&order=${last_order_id}&parts=${parts}`);
    }
    setOrderNumParts(parts, order_id) {
        return eposAxios.get(`/index.php?page=ajax&function=setOrderNumParts&parts=${parts}&order_id=${order_id}`);
    }
    async setItemStatusAssembled(items,tag,receipt,parts) {
        //return eposAxios.post(`/index.php?page=ajax&function=setItemStatusAssembled&items=${items}&tag=${tag}&receipt=${receipt}&parts=${parts}`);

        const params = new URLSearchParams();
        params.append('items', items);
        params.append('tag', tag);
        params.append('receipt', receipt);
        params.append('parts', parts);
        
       return eposAxios.post(
            '/index.php?page=ajax&function=setItemStatusAssembled',
            params,
            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );
    }
    async setOrderNote(order_id,parts,userid,ordernote,notetype) {
        return epos2Axios.post('/api/orders/'+order_id+'/ordernote',{
            parts: parts,
            userid: userid,
            ordernote: ordernote,
            notetype: notetype
        });
    }

    printLabel(order_id, count, workstation_id) {
        return epos2Axios.post('/api/print/label',{
            order_id: order_id,
            count: count,
            workstation_id: workstation_id
        });
    }
}

export default new AssembleDataService();
